<template>
<div class="TableListItem tableLS tableJX">
  <basic :finalSkill="finalSkill"/>
  <skill :finalSkill="finalSkill"/>
  </div>
</template>

<script setup>

import { defineProps, ref, computed } from 'vue'
import basic from './final_skill_c/basic.vue';
import skill from './final_skill_c/skill.vue';
const props = defineProps({
  role_data: {
    type: Object,
    default: () => ({})
  },
})

const finalSkill = computed(() => {
  return props.role_data?.finalSkill || {}
})
</script>

<style lang="scss" scoped>

.TableListItem{
  display: flex;
}
</style>